import { ExpandablePanel } from '@/features/filter';
import CategoriesContent from './categories-content';
import { useVideosFilterContext } from '../../context';
const DesktopCategories = () => {
  const {
    activeCategories,
    toggleCategory
  } = useVideosFilterContext();
  const changeHandler = (value: number) => toggleCategory(value);
  return <div className='relative hidden h-fit w-[221px] min-w-[221px] border-y border-solid border-border-gray-light lg:block' data-sentry-component="DesktopCategories" data-sentry-source-file="desktop.tsx">
            <ExpandablePanel defaultState='open' uniqueKey='categories-desktop-panel' mode='desktop' title='فیلتر بر اساس دسته‌بندی' data-sentry-element="ExpandablePanel" data-sentry-source-file="desktop.tsx">
                <CategoriesContent changeHandler={changeHandler} activeFilters={activeCategories} mode='desktop' data-sentry-element="CategoriesContent" data-sentry-source-file="desktop.tsx" />
            </ExpandablePanel>
        </div>;
};
export default DesktopCategories;